const { 
  REACT_APP_API_BASE,
  REACT_APP_ADDRESS_API,
  REACT_APP_API_KEY,
  REACT_APP_CDN_BASE,
  REACT_APP_CDN_IMAGES_BASE,
  REACT_APP_IFRAME_BASE,
  REACT_APP_ADOPT_BASE,
  REACT_APP_KIOSK_BASE,
  REACT_APP_GLOBAL_API,
  REACT_APP_INTEGRATION_API,
  REACT_APP_MAGIC_LINK_API,
  REACT_APP_API_SERVICE_URL,
  REACT_APP_FLAG_ENABLE_CREDENTIAL_LIST,
} = process.env

interface IConfig {
  baseAPI: string,
  integrationAPI: string,
  addressAPI: string,
  apiKey: string,
  cdnBase: string,
  cdnImagesBase: string,
  iframeBase: string,
  adoptBase: string,
  kioskBase: string,
  globalAPI: string,
  magicLinkAPI: string
  serviceAPI: string
  flags: {
    FLAG_ENABLE_CREDENTIAL_LIST: boolean
  }
}

export default {
  baseAPI: REACT_APP_API_BASE || 'http://localhost',
  integrationAPI: REACT_APP_INTEGRATION_API || 'http://localhost',
  addressAPI: REACT_APP_ADDRESS_API,
  apiKey: REACT_APP_API_KEY || '',
  cdnBase: REACT_APP_CDN_BASE || '',
  cdnImagesBase: REACT_APP_CDN_IMAGES_BASE || '',
  iframeBase: REACT_APP_IFRAME_BASE || '',
  adoptBase: REACT_APP_ADOPT_BASE || '',
  kioskBase: REACT_APP_KIOSK_BASE || '',
  globalAPI: REACT_APP_GLOBAL_API || '',
  magicLinkAPI: REACT_APP_MAGIC_LINK_API || '',
  serviceAPI: REACT_APP_API_SERVICE_URL || '',
  flags: {
    // set REACT_APP_FLAG_ENABLE_CREDENTIAL_LIST=true to allow the new flow.
    FLAG_ENABLE_CREDENTIAL_LIST: REACT_APP_FLAG_ENABLE_CREDENTIAL_LIST === 'true',
  },
} as IConfig
